import { notify } from "@general-backoffice/core/index";

import i18n from "../../i18n";

/** Raw server messages that should be replaced with friendly, translated copy. */
const GENERIC_SERVER_ERRORS = new Set([
  "Internal Server Error",
  "Request failed with status code 500",
  "Network Error",
]);

/**
 * Shows an error notification and, by default, rethrows.
 *
 * The friendly message is translated: it used to be a hardcoded Spanish
 * sentence shown to English-locale users as well.
 */
const handleError = (msg: string, rethrow = true): void => {
  const message = GENERIC_SERVER_ERRORS.has(msg) ? i18n.t("utils:errors.serverUnavailable") : msg;
  notify.error(message);
  if (rethrow) throw new Error(message);
};

export default handleError;
